import axios from "axios";
import { supabase } from "./supabaseClient";
import { isNativeAndroid, isNativeIOS, runNativePurchase, runNativeApplePurchase } from "./nativeBilling";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function authHeader() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Start a £4.99 / 7-day Boost checkout for an owned active event.
// Returns the Stripe-hosted checkout URL to redirect to.
export async function startBoostCheckout(eventId) {
  if (isNativeIOS()) {
    await runNativeApplePurchase("app.roadrnr.boost", { event_id: eventId });
    return { native: true, ok: true };
  }
  if (isNativeAndroid()) {
    await runNativePurchase("roadrnr_boost", { event_id: eventId });
    return { native: true, ok: true };
  }
  const headers = await authHeader();
  const { data } = await axios.post(
    `${API}/boost/checkout`,
    { event_id: eventId, origin_url: window.location.origin },
    { headers }
  );
  return data; // { checkout_url, session_id }
}

// Poll payment + activation status for a checkout session (unauthenticated).
export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data; // { status, payment_status, boost_activated, event_id }
}

// Which of the caller's own events currently have an active boost.
export async function getMyBoosts() {
  try {
    const headers = await authHeader();
    const { data } = await axios.get(`${API}/boost/mine`, { headers });
    return data?.boosted || {};
  } catch {
    return {};
  }
}
